<template>
<div class="site-footer ">


   <div class="row">
      <div class="col s12 yo-align-center">
         BioMedia srl - via Libero Temolo 4 ­ torre U8 -­ 20126 Milano ­- P.IVA 10691860158
      </div>
   </div>
</div>
</template>

<script>

export default {
  name: 'site-footer',
  components: {
  }
}
</script>
<style>
.site-footer{
    
}
</style>




// WEBPACK FOOTER //
// src/components/Site-footer.vue